// @flow


export type SetReadyPayload = {
}

const id = 'session/SET_READY'

export const setReady = (): Action<SetReadyPayload> => ({
  type: id,
  payload: {
  }
})

setReady.id = id